t = require('views/internal/teacup-with-helpers')('popover_remove_guest_from_team_boards')
joinn = require 'joinn'

module.exports = t.renderable ({ fullName, isOnlyAdminBoardNames, teamBoardCount, boardsRemainingCountLocalized, teamBoardCountLocalized }) ->
  t.p { style: 'padding: 6px' }, ->
    if isOnlyAdminBoardNames.length == 0
      t.format 'remove from all team boards-disclaimer', { fullName, teamBoardCountLocalized }
    else
      if isOnlyAdminBoardNames.length == 1
        t.format 'user is the only board admin', { fullName, adminBoardName: isOnlyAdminBoardNames[0] }
      else
        t.format 'user is the only board admin plural', { fullName, adminBoardNames: joinn isOnlyAdminBoardNames.slice(0), ', ', " #{ t.l('and') } " }

      if isOnlyAdminBoardNames.length < teamBoardCount
        t.p { style: 'padding: 0 6px' }, ->
          t.format 'remove from all other team boards-disclaimer', { fullName, boardsRemainingCountLocalized }

  if isOnlyAdminBoardNames.length == teamBoardCount
    t.button '.button-link.primary.u-width-100.js-confirm-remove-from-team-boards', ->
      t.format 'remove from all team boards-got-it'
  else
    t.button '.button-link.primary.u-width-100.js-confirm-remove-from-team-boards.negate', ->
      t.format 'remove from all team boards-confirm'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_remove_guest_from_team_boards.coffee